import { ThemeProvider } from './contexts/ThemeContext';
import { I18nProvider } from './i18n';
import { RouterProvider } from './router/RouterContext';
import { RouterView } from './router/RouterView';
import { TopNav } from './components/TopNav';
import { Footer } from './components/Footer';
import KanamePage from './pages/KanamePage';
import GirlsBandTabiPage from './pages/GirlsBandTabiPage';
import LegalPage from './pages/LegalPage';
import BusinessPage from './pages/BusinessPage';
import VerifyPage from './pages/VerifyPage';
import DeleteAccountPage from './pages/DeleteAccountPage';

const routes = [
  { path: '/', element: <GirlsBandTabiPage /> },
  { path: '/rana', element: <KanamePage /> },
  { path: '/business', element: <BusinessPage /> },
  { path: '/legal', element: <LegalPage /> },
  { path: '/verify', element: <VerifyPage /> },
  { path: '/delete-account', element: <DeleteAccountPage /> },
];

function NotFound() {
  return (
    <main style={{ padding: '6rem 1.5rem', textAlign: 'center', color: 'var(--muted)' }}>
      <p style={{ fontSize: '4rem', margin: '0 0 1rem' }}>404</p>
      <p>페이지를 찾을 수 없습니다.</p>
    </main>
  );
}

function AppShell() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', color: 'var(--text)' }}>
      <TopNav />
      <RouterView routes={routes} fallback={<NotFound />} />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <I18nProvider>
        <RouterProvider>
          <AppShell />
        </RouterProvider>
      </I18nProvider>
    </ThemeProvider>
  );
}

export default App;
